import { get, post } from "@/services/axiosUitils";

export interface HomePageData {
  success: {
    code: string;
    message: string;
  };
  user: string;
  today_date_local: string;
  "Today's Nutrition": {
    "Total Calories": number;
    "Total Carbohydrates": number;
    "Total Proteins": number;
    "Total Fats": number;
    "Total Fiber": number;
    "Total Net Carbs": number;
    "Total Sugar": number;
    "Total Saturated Fat": number;
    "Total Trans Fat": number;
  };
  "Today's Activity": {
    "Total Steps": number;
    BPM: number;
    "Calories Burned": number;
    Sleep: number;
    "Active Minutes": number;
    spo2_percent: number;
    breathing_rate: number;
    skin_temp_celsius: number;
    hrv_rmssd: number;
  };
  "Intermittent Fasting": {
    Status: string;
    "Time Remaining": string | null;
    "Fasting Time": number | null;
    "Fasting Time UI": string | null;
    "Time Remaining UI": string | null;
    "Time Started": string;
    "Time Ended": string;
    "Elapsed Time": string | null;
    "Elapsed Time UI": string | null;
    "Elapsed Seconds": number | null;
    "Duration Minutes": number;
    "Duration UI": string;
    "Fasting Goal": string | null;
    "Fasting Goal Hours": number | null;
  };
  "Today's Goals": {
    "Total Calories Goal": number;
    "Total Activity Goal": number;
  };
  "Body Mass Index": {
    BMI: number;
    "Weight kg": number;
    "Height cm": number;
    "Weight lbs": number;
    "Height ft": string;
    "BMI Category": string;
    "BMI Category Color": string;
  };
  "Medication Reminders": Array<{
    "Timing ID": string;
    "Medication ID": string;
    "Medication Name": string;
    "Medication Time": string;
    "Full Time String": string;
    Status: string;
    Frequency: string;
  }>;
  "Weekly Calorie Burned Trend": {
    graph: Array<{ day: string; value: number }>;
    start_date: string;
    end_date: string;
  };
  "Weekly Sleep Trend": {
    graph: Array<{ day: string; value: number }>;
    start_date: string;
    end_date: string;
  };
  "Weekly Calorie Intake Trend": {
    graph: Array<{ day: string; value: number }>;
    start_date: string;
    end_date: string;
  };
  "Gut Health Score": number;
  "Food Score": number;
  "Lifestyle Score": number;
  Classification: string;
  "Health Insights": {
    carb_fiber_ratio_daily: {
      value: number;
      label: string;
    };
    bad_fat_ratio_daily: {
      value: number;
      label: string;
    };
    sugar_ratio_daily: {
      value: number;
      label: string;
    };
    protein_fiber_ratio_daily: {
      value: number;
      label: string;
    };
  };
}

class HomeService {
  private static instance: HomeService;

  private constructor() { }

  public static getInstance(): HomeService {
    if (!HomeService.instance) {
      HomeService.instance = new HomeService();
    }
    return HomeService.instance;
  }

  /**
   * Get home page data including nutrition, activity, BMI, and weekly trends
   */
  async getHomePageData(): Promise<HomePageData> {
    const response = await get<HomePageData>("/food_scanner/food-home-page/");
    return response;
  }

  /**
   * Start intermittent fasting
   */
  async startFasting(): Promise<any> {
    const response = await post("/food_scanner/intermittent-fasting/", {
      action: "start",
    });
    return response;
  }

  /**
   * Stop/End intermittent fasting
   */
  async stopFasting(): Promise<any> {
    const response = await post("/food_scanner/intermittent-fasting/", {
      action: "end",
    });
    return response;
  }
}

export default HomeService.getInstance();
